export default "__VITE_ASSET__klSbUSLt__"